var YesNoCtrl = function($scope, close, gettextCatalog) {
  $scope.close = function(result) {
    close(result, 500);
  };
};

module.exports = YesNoCtrl;


// WEBPACK FOOTER //
// ./client/src/app/modules/order/YesNoCtrl.js